import moment from 'moment'

export const convertUserToSegmentUser = (userData) => {
  const Email = userData?.Email
  const Surname = userData?.Surname
  const FirstName = userData?.FirstName
  const Gender = userData?.Gender
  const Mobile = userData?.Mobile

  // TODO
  /* segment */
  return {
    email: Email || '',
    first_name: FirstName || '',
    last_name: Surname || '',
    mobile: Mobile || '',
    cf_gender: Gender || '',
    gender: Gender || '',
  }
}

export const convertWholesalerUserToSegmentUser = (userData) => {
  /**
   *    ACCOUNT HOLDER INFORMATION
   */
  const LegalEntityName = userData?.LegalEntityName
  const TradingName = userData?.TradingName
  const EntityType = userData?.EntityType

  const ABN = userData?.ABN
  const ACN = userData?.ACN
  const LiquorLicenseNumber = userData?.LiquorLicenseNumber

  const OutletType = userData?.OutletType
  const BusinessAddress = userData?.BusinessAddress
  const BusinessCity = userData?.BusinessCity

  const BusinessState = userData?.BusinessState
  const BusinessPostalCode = userData?.BusinessPostalCode

  /**
   *    MAIN CONTACT INFORMATION
   */
  const FirstName = userData?.FirstName
  const Surname = userData?.Surname
  const DOB = userData?.DOB

  const Position = userData?.Position
  const ContactNumber = userData?.ContactNumber
  const Email = userData?.Email

  /**
   *    DELIVERY PREFERENCES
   */
  const PreferredDeliveryDay = userData?.PreferredDeliveryDay
  const PreferredDeliveryWindow = userData?.PreferredDeliveryWindow
  const DeliveryInstructions = userData?.DeliveryInstructions

  /**
   *    AGREE TERMS
   */
  const ApplyCommercialCreditTerms = userData?.ApplyCommercialCreditTerms
  const AgreeTerms = userData?.AgreeTerms

  /**
   *    APPLICATION FOR COMMERCIAL CREDIT
   */
  const CommercialCreditDirectors = userData?.CommercialCreditDirectors
  const TradeReferences = userData?.TradeReferences

  return {
    legalEntityName: LegalEntityName || '',
    tradingName: TradingName || '',
    entityType: EntityType || '',
    ABN: ABN || '',
    ACN: ACN || '',
    liquorLicenseNumber: LiquorLicenseNumber || '',
    qutletType: OutletType || '',
    businessAddress: BusinessAddress || '',
    businessCity: BusinessCity || '',
    businessState: BusinessState || '',
    businessPostalCode: BusinessPostalCode || '',
    // FirstName: FirstName || '',
    // Surname: Surname || '',
    dob: moment(DOB).format('DD/MM/YYYY') || '',
    position: Position || '',
    //ContactNumber: ContactNumber || '',
    //Email: Email || '',
    preferredDeliveryDay: PreferredDeliveryDay || '',
    preferredDeliveryWindow: PreferredDeliveryWindow || '',
    deliveryInstructions: DeliveryInstructions || '',
    applyCommercialCreditTerms: ApplyCommercialCreditTerms || '',
    agreeTerms: AgreeTerms || '',
    commercialCreditDirectors: CommercialCreditDirectors || [],
    tradeReferences: TradeReferences || [],
    email: Email || '',
    first_name: FirstName || '',
    last_name: Surname || '',
    mobile: ContactNumber || '',
  }
}
